import { Box, Button, Text, TextInput } from '@ksyos/design-system';
import type { IAltoStepProps } from '../../NewAltoDermaOthProcedure';
import { translateKey } from '../../../../../translate';
import { StyledFormGroup } from '../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function BsnLogin(props: IAltoStepProps) {
    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                gap={8}
            >
                <Text size="xl">Ter controle vragen wij je het BSN van {props.csPatientName} in te vullen.</Text>
                <StyledFormGroup
                    hasErrors={props.errors.has('bsn')}
                    label={`Het BSN van ${props.csPatientName}`}
                    layout="vertical"
                >
                    <TextInput
                        error={
                            props.errors.get('bsn') ? translateKey('validation.' + props.errors.get('bsn')) : undefined
                        }
                        onChange={(e) => {
                            props.handleChange({
                                patient: { ...props.procedure.customControlData.patient, bsn: e.target.value },
                            });
                        }}
                        onEnterKeyPress={props.validateAndGoToNextStep}
                        placeholder="Vul het BSN..."
                        value={props.procedure.customControlData.patient.bsn ?? ''}
                    />
                </StyledFormGroup>
            </Box>
            <Button
                color="secondary"
                onClick={props.validateAndGoToNextStep}
                variant="solid"
                width="full"
            >
                Verder
            </Button>
        </>
    );
}
